import PropTypes from 'prop-types';
import _ from 'lodash';
import { COLORS_PROP_TYPE } from '../color/constants';
import { SVG_PROP_TYPE } from '../vectorImage/constants';
import SIZES_JSON from '../iconography/iconography_sizes.json';
import CheckSvg from '../iconography/icons/Check';
import CheckChunkySvg from '../iconography/icons/CheckChunky';
export var SIZES = _.chain(Object.keys(SIZES_JSON)).filter(function (size) {
  return size.startsWith('icon-') && !size.includes('halo');
}).map(function (size) {
  return size.replace('icon-', '');
}).value();
export var ICON_TYPE_PROP_TYPE = SVG_PROP_TYPE;
export var ICON_SIZE_PROP_TYPE = PropTypes.oneOf(SIZES);
export var COLOR_PROP_TYPE = COLORS_PROP_TYPE;
export var STROKE_COLOR_ICONS = [CheckSvg, CheckChunkySvg];